<ng-container *ngIf="favoriteActions$ | async as favoriteActions">
  <mg-btn
    variant="outlined"
    iconSet="minga"
    icon="mg-more-vert"
    [matMenuTriggerFor]="assignDropdown">
    {{ MESSAGES.MORE_ACTIONS_BTN }}
  </mg-btn>
  <mat-menu #assignDropdown="matMenu">
    <ng-container *ngFor="let option of assignActions">
      <button
        *ngIf="option.hasPermission$ | async"
        mat-menu-item
        class="action-dropdown"
        variant="outlined"
        [attr.data-analytics]="option.id"
        [attr.data-test]="option.id"
        (click)="option.onPress()">
        <mg-btn
          variant="icon"
          iconSet="minga"
          [icon]="(favoriteActionKeys$ | async).includes(option.key) ? 'mg-points-menu' : 'mg-points-menu-o'"
          (click)="$event.stopPropagation(); toggleFavoriteAction(option)">
        </mg-btn>
        <mg-icon
          [iconName]="option.icon"
          [iconColor]="option.iconColor"></mg-icon>
        <mg-text variant="body-md">{{ option.label }} </mg-text>
      </button>
    </ng-container>
  </mat-menu>
</ng-container>
